<template>
    <sp-transition name="slide-x-left-bounce">
        <div class="events-list"
             v-if="isOpen"
        >
            <div class="close" @click="closeModals(name)">
                <icon class="icon-close" icon="close" :width="22" :height="22"/>
            </div>
            <slot name="action"></slot>
            <div class="events" id="events">
                <div class="wrapper">
                    <transition-group name="slide-fade" tag="div">
                        <div class="event" v-for="(item, index) in items" :key="index">
                            <slot v-bind:item="item"></slot>
                        </div>
                    </transition-group>
                </div>
                <plug v-if="0 === items.length && !loading" icon="exclamation-solid" title="Sorry, no items to display" :width="45" :height="55" color="#e2e2e2"></plug>
            </div>
            <div class="loading" v-show="loading">
                <div class="wrapper">
                    <v-progress-circular
                        indeterminate
                        color="rgba(255, 255, 255)"
                    ></v-progress-circular>
                    Loading...
                </div>
            </div>
            </div>
    </sp-transition>
</template>

<script>
import { getEventTargetName } from '@/helpers/Utils'
import PerfectScrollbar from 'perfect-scrollbar'
import Icon from '@/components/atoms/Icon'
import Plug from '@/components/atoms/Plug'
import SpTransition from '@/components/transitions/SpTransition'


export default {
    name: 'ResourceList',
    components: {
        Icon,
        Plug,
        SpTransition
    },
    data () {
        return {
            isOpen: this.value,
            items: [],
            loading: false,
            isMoreItems: true,
            perPage: 100,
            page: 1,
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true
        },
        closeModals: {
            type: Function,
            required: true,
        },
        handler: {
            type: Function,
            required: true
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (value) {
                this.value = this.isOpen
                this.$emit('input', this.isOpen)
            }
        }
    },
    watch: {
        value: {
            handler (value) {
                this.isOpen = value
                this.isMoreItems = true;
                if (this.isOpen) {
                    setTimeout(() => {
                        const container = document.querySelector('#events')

                        let ps = new PerfectScrollbar(container, {
                            wheelSpeed: 2,
                            wheelPropagation: true,
                            minScrollbarLength: 20
                        })

                        ps.update()

                        container.addEventListener('ps-y-reach-end', () => {
                            if (!this.loading && this.isMoreItems) {
                                this.page++
                                this.getItems()
                            }
                        })
                    }, 500)
                    this.items = [];
                    this.getItems()
                }
            }
        },
    },
    methods: {
        applyFilters() {
            this.page = 1;
            this.isMoreItems = true;
            this.items = [];
            this.getItems();
        },
        async getItems () {
            this.loading = true
            this.isOpen = true
            this.$emit('loading', this.loading)
            const items = await this.handler(this.page, this.perPage)
            if (this.perPage > items.length) {
                this.isMoreItems = false
            }
            this.setEventData(items, this.isMoreItems)
            this.loading = false
            this.$emit('loading', this.loading)
        },
        setEventData (events) {
            this.items.push(...events)

            setTimeout(() => {
                document.getElementById('events').addEventListener('ps-y-reach-end', () => {
                    if (!this.loading && this.isMoreItems) {
                        this.page++
                        this.getItems()
                    }
                })
            }, 0)
        },
    }
}
</script>

<style lang="scss">
.events-list {
    background: white;
    width: 340px;
    position: absolute;
    overflow: hidden;
    top: get($header-config, default, height);
    right: 0;
    z-index: 3;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.45);
    .close {
        position: absolute;
        top: 13px;
        right: 7px;
        cursor: pointer;
        color: $font;

        &:hover {
            opacity: 0.7
        }

        i {
            font-size: 20px;
            font-weight: bold;
        }
    }

    .loading {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;

        .wrapper {
            color: $white;
            font-size: 16px;
            font-weight: bold;
        }
    }

    .no-data {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        padding: 50px 0;
    }

    .events {
        position: relative;
        /*min-height: 100px;*/
        height: calc(100vh - 109px);
        overflow: hidden;
    }

    .event {
        margin: 12px 5px;
        position: relative;
    }

    .filter-icon {
        margin-top: -2px;
        margin-right: 25px;
        cursor: pointer;
        transition: opacity 0.3s;
        color: $font;

        &:hover {
            opacity: 0.5;
        }
    }
}

// animation related
.slide-fade-enter-active {
    transition: all .5s ease;
}
.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(15px);
    opacity: 0;
}

</style>
